/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис сихронизации объектов
 */

/**
 * Сервис для сихронизации объектов
 */
export class SyncServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод частичного обновления дома, только данными из DaData.
   * Метод доступен для: admin, service
   */
  PostSyncBuilding = (req: PostSyncBuildingRequestDto, init?: RequestInit): Promise<PostSyncBuildingResponseDto> => {
    return fm.request<PostSyncBuildingRequestDto, PostSyncBuildingResponseDto>(`${this.host}/access_control/api/v1/sync/building`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка домов для обновления.
   * Метод доступен для: admin, service
   */
  GetSyncBuildings = (req: GetSyncBuildingsRequestDto, init?: RequestInit): Promise<GetSyncBuildingsResponseDto> => {
    return fm.request<GetSyncBuildingsRequestDto, GetSyncBuildingsResponseDto>(`${this.host}/access_control/api/v1/sync/buildings${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Дом для синхронизации
 */
export type BuildingSyncRequestDto = {
  /**
   * Идентификатор дома
   */
  id: number
  /**
   * ОРПОН
   */
  orpon?: string
  /**
   * Город
   */
  city?: string
  /**
   * Улица
   */
  street?: string
  /**
   * Номер дома
   */
  number?: string
  /**
   * ОРПОН города, в котором находится дом
   */
  cityOrpon?: string
  /**
   * ОРПОН региона
   */
  regionOrpon?: string
  /**
   * Наименование муниципального района.
   * # Диапазон: 0..64
   */
  area?: string | null
  /**
   * ОРПОН муниципального района.
   * # Диапазон: 0..9999999999
   */
  areaOrpon?: string | null
  /**
   * КЛАДР муниципального района.
   * # Диапазон: 0..32
   */
  areaKladr?: string | null
  /**
   * Признак принадлежности населённого пункта к столичному статусу.
   * 1 — центр района.
   * 2 — центр региона.
   * 3 — центр района и региона.
   * 4 — центральный район региона.
   * 0 — ничего из перечисленного.
   * # Диапазон: 0..4
   */
  capitalMarker?: number | null
  /**
   * КЛАДР-код города.
   * # Диапазон: 0..17
   */
  cityKladr?: string | null
  /**
   * КЛАДР-код строения.
   * # Диапазон: 0..17
   */
  kladr?: string | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — страна.
   * 1 — регион.
   * 3 — район.
   * 4 — город.
   * 5 — район города.
   * 6 — населенный пункт.
   * 7 — улица.
   * 8 — дом.
   * 9 — квартира.
   * 65 — планировочная структура.
   * 90 — доп. территория.
   * 91 — улица в доп. территории.
   * -1 — иностранный или пустой.
   * # Диапазон: -1..99
   */
  fiasLevel?: number | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — актуальный.
   * 1-50 — переименован.
   * 51 — переподчинен.
   * 99 — удален.
   * # Диапазон: 0..99
   */
  fiasActualityState?: number | null
  /**
   * Координаты: широта
   */
  geoLat?: number | null
  /**
   * Координаты: долгота
   */
  geoLon?: number | null
  /**
   * Код ОКАТО
   */
  okato?: string | null
  /**
   * Код ОКТМО
   */
  oktmo?: string | null
  /**
   * Почтовый индекс
   */
  postalCode?: number | null
  /**
   * Наименование региона.
   * # Диапазон: 0..64
   */
  region?: string | null
  /**
   * КЛАДР-код региона.
   * # Диапазон: 0..32
   */
  regionKladr?: string | null
  /**
   * КЛАДР-код улицы.
   * # Диапазон: 0..32
   */
  streetKladr?: string | null
  /**
   * ОРПОН улицы.
   * # Диапазон: 0..9999999999
   */
  streetOrpon?: string | null
  /**
   * КЛАДР-код дома.
   * # Диапазон: 0..32
   */
  houseKladr?: string | null
}
/**
 * Дом для синхронизации
 */
export type BuildingSyncResponseDto = {
  /**
   * Идентификатор дома
   */
  id: number
  /**
   * ОРПОН
   */
  orpon: string
  /**
   * Город
   */
  city: string
  /**
   * Улица
   */
  street: string
  /**
   * Номер дома
   */
  number: string
  /**
   * ОРПОН города, в котором находится дом
   */
  cityOrpon: string
  /**
   * ОРПОН региона
   */
  regionOrpon: string
  /**
   * Наименование муниципального района.
   * # Диапазон: 0..64
   */
  area: string | null
  /**
   * ОРПОН муниципального района.
   * # Диапазон: 0..9999999999
   */
  areaOrpon: string | null
  /**
   * КЛАДР муниципального района.
   * # Диапазон: 0..32
   */
  areaKladr: string | null
  /**
   * Признак принадлежности населённого пункта к столичному статусу.
   * 1 — центр района.
   * 2 — центр региона.
   * 3 — центр района и региона.
   * 4 — центральный район региона.
   * 0 — ничего из перечисленного.
   * # Диапазон: 0..4
   */
  capitalMarker: number | null
  /**
   * КЛАДР-код города.
   * # Диапазон: 0..17
   */
  cityKladr: string | null
  /**
   * КЛАДР-код строения.
   * # Диапазон: 0..17
   */
  kladr: string | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — страна.
   * 1 — регион.
   * 3 — район.
   * 4 — город.
   * 5 — район города.
   * 6 — населенный пункт.
   * 7 — улица.
   * 8 — дом.
   * 9 — квартира.
   * 65 — планировочная структура.
   * 90 — доп. территория.
   * 91 — улица в доп. территории.
   * -1 — иностранный или пустой.
   * # Диапазон: -1..99
   */
  fiasLevel: number | null
  /**
   * Уровень детализации, до которого адрес найден в ФИАС.
   * 0 — актуальный.
   * 1-50 — переименован.
   * 51 — переподчинен.
   * 99 — удален.
   * # Диапазон: 0..99
   */
  fiasActualityState: number | null
  /**
   * Координаты: широта
   */
  geoLat: number | null
  /**
   * Координаты: долгота
   */
  geoLon: number | null
  /**
   * Код ОКАТО
   */
  okato: string | null
  /**
   * Код ОКТМО
   */
  oktmo: string | null
  /**
   * Почтовый индекс
   */
  postalCode: number | null
  /**
   * Наименование региона.
   * # Диапазон: 0..64
   */
  region: string | null
  /**
   * КЛАДР-код региона.
   * # Диапазон: 0..32
   */
  regionKladr: string | null
  /**
   * КЛАДР-код улицы.
   * # Диапазон: 0..32
   */
  streetKladr: string | null
  /**
   * ОРПОН улицы.
   * # Диапазон: 0..9999999999
   */
  streetOrpon: string | null
  /**
   * КЛАДР-код дома.
   * # Диапазон: 0..32
   */
  houseKladr: string | null
}
/**
 * Запрос получения списка домов для обновления
 */
export type GetSyncBuildingsRequestDto = {
  /**
   * Количество.
   * По умолчанию 10.
   * # Диапазон: 10..5000
   */
  batchSize: number
  /**
   * Дата, старше которой должны вернуться записи для синхронизации
   */
  lastSyncBeforeAt: string
}
/**
 * Ответ на запрос получения списка домов для обновления
 */
export type GetSyncBuildingsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Дома
   */
  readonly data: GetSyncBuildingsResponseBuildingListDto
  /**
   * Ошибка
   */
  readonly error: GetSyncBuildingsResponseErrorDto
}>
/**
 * Список домов
 */
export type GetSyncBuildingsResponseBuildingListDto = {
  /**
   * Список домов
   */
  buildings: BuildingSyncResponseDto[]
}
/**
 * Ошибка
 */
export type GetSyncBuildingsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetSyncBuildingsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос частичного обновления дома
 */
export type PostSyncBuildingRequestDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Передается в случае когда изменения данных не требуются, но необходимо зафиксировать дату синхронизации
   */
  readonly buildingId: number
  /**
   * Дом с обновленными данными из DaData
   */
  readonly data: BuildingSyncRequestDto
}>
/**
 * Ответ на запрос частичного обновления дома
 */
export type PostSyncBuildingResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostSyncBuildingResponseErrorDto
}>
/**
 * Ошибка
 */
export type PostSyncBuildingResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type PostSyncBuildingResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Дом для синхронизации
   */
  "BuildingSync": {
    "kind": "class",
    "text": "Дом для синхронизации",
    "fields": {
      /**
       * Идентификатор дома
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН",
      },
      /**
       * Город
       */
      "city": {
        "type": "string",
        "text": "Город",
      },
      /**
       * Улица
       */
      "street": {
        "type": "string",
        "text": "Улица",
      },
      /**
       * Номер дома
       */
      "number": {
        "type": "string",
        "text": "Номер дома",
      },
      /**
       * ОРПОН города, в котором находится дом
       */
      "cityOrpon": {
        "type": "int64",
        "text": "ОРПОН города, в котором находится дом",
      },
      /**
       * ОРПОН региона
       */
      "regionOrpon": {
        "type": "int64",
        "text": "ОРПОН региона",
      },
      /**
       * Наименование муниципального района.
       * # Диапазон: 0..64
       */
      "area": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование муниципального района.\n# Диапазон: 0..64",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * ОРПОН муниципального района.
       * # Диапазон: 0..9999999999
       */
      "areaOrpon": {
        "type": "google.protobuf.Int64Value",
        "text": "ОРПОН муниципального района.\n# Диапазон: 0..9999999999",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 9999999999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999999999"
          },
        }
      },
      /**
       * КЛАДР муниципального района.
       * # Диапазон: 0..32
       */
      "areaKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР муниципального района.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * Признак принадлежности населённого пункта к столичному статусу.
       * 1 — центр района.
       * 2 — центр региона.
       * 3 — центр района и региона.
       * 4 — центральный район региона.
       * 0 — ничего из перечисленного.
       * # Диапазон: 0..4
       */
      "capitalMarker": {
        "type": "google.protobuf.Int32Value",
        "text": "Признак принадлежности населённого пункта к столичному статусу.\n1 — центр района.\n2 — центр региона.\n3 — центр района и региона.\n4 — центральный район региона.\n0 — ничего из перечисленного.\n# Диапазон: 0..4",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
      /**
       * КЛАДР-код города.
       * # Диапазон: 0..17
       */
      "cityKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код города.\n# Диапазон: 0..17",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
        }
      },
      /**
       * КЛАДР-код строения.
       * # Диапазон: 0..17
       */
      "kladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код строения.\n# Диапазон: 0..17",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
        }
      },
      /**
       * Уровень детализации, до которого адрес найден в ФИАС.
       * 0 — страна.
       * 1 — регион.
       * 3 — район.
       * 4 — город.
       * 5 — район города.
       * 6 — населенный пункт.
       * 7 — улица.
       * 8 — дом.
       * 9 — квартира.
       * 65 — планировочная структура.
       * 90 — доп. территория.
       * 91 — улица в доп. территории.
       * -1 — иностранный или пустой.
       * # Диапазон: -1..99
       */
      "fiasLevel": {
        "type": "google.protobuf.Int32Value",
        "text": "Уровень детализации, до которого адрес найден в ФИАС.\n0 — страна.\n1 — регион.\n3 — район.\n4 — город.\n5 — район города.\n6 — населенный пункт.\n7 — улица.\n8 — дом.\n9 — квартира.\n65 — планировочная структура.\n90 — доп. территория.\n91 — улица в доп. территории.\n-1 — иностранный или пустой.\n# Диапазон: -1..99",
        "rules": {
          "min": {
            "value": -1,
            "message": "Значение не входит в допустимый диапазон. Минимум: -1"
          },
          "max": {
            "value": 99,
            "message": "Значение не входит в допустимый диапазон. Максимум: 99"
          },
        }
      },
      /**
       * Уровень детализации, до которого адрес найден в ФИАС.
       * 0 — актуальный.
       * 1-50 — переименован.
       * 51 — переподчинен.
       * 99 — удален.
       * # Диапазон: 0..99
       */
      "fiasActualityState": {
        "type": "google.protobuf.Int32Value",
        "text": "Уровень детализации, до которого адрес найден в ФИАС.\n0 — актуальный.\n1-50 — переименован.\n51 — переподчинен.\n99 — удален.\n# Диапазон: 0..99",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 99,
            "message": "Значение не входит в допустимый диапазон. Максимум: 99"
          },
        }
      },
      /**
       * Координаты: широта
       */
      "geoLat": {
        "type": "google.protobuf.DoubleValue",
        "text": "Координаты: широта",
      },
      /**
       * Координаты: долгота
       */
      "geoLon": {
        "type": "google.protobuf.DoubleValue",
        "text": "Координаты: долгота",
      },
      /**
       * Код ОКАТО
       */
      "okato": {
        "type": "google.protobuf.Int64Value",
        "text": "Код ОКАТО",
      },
      /**
       * Код ОКТМО
       */
      "oktmo": {
        "type": "google.protobuf.Int64Value",
        "text": "Код ОКТМО",
      },
      /**
       * Почтовый индекс
       */
      "postalCode": {
        "type": "google.protobuf.Int32Value",
        "text": "Почтовый индекс",
      },
      /**
       * Наименование региона.
       * # Диапазон: 0..64
       */
      "region": {
        "type": "google.protobuf.StringValue",
        "text": "Наименование региона.\n# Диапазон: 0..64",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * КЛАДР-код региона.
       * # Диапазон: 0..32
       */
      "regionKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код региона.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * КЛАДР-код улицы.
       * # Диапазон: 0..32
       */
      "streetKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код улицы.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
      /**
       * ОРПОН улицы.
       * # Диапазон: 0..9999999999
       */
      "streetOrpon": {
        "type": "google.protobuf.Int64Value",
        "text": "ОРПОН улицы.\n# Диапазон: 0..9999999999",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 9999999999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999999999"
          },
        }
      },
      /**
       * КЛАДР-код дома.
       * # Диапазон: 0..32
       */
      "houseKladr": {
        "type": "google.protobuf.StringValue",
        "text": "КЛАДР-код дома.\n# Диапазон: 0..32",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 32,
            "message": "Значение не входит в допустимый диапазон. Максимум: 32"
          },
        }
      },
    },
  },
  /**
   * Запрос получения списка домов для обновления
   */
  "GetSyncBuildingsRequest": {
    "kind": "class",
    "text": "Запрос получения списка домов для обновления",
    "fields": {
      /**
       * Количество.
       * По умолчанию 10.
       * # Диапазон: 10..5000
       */
      "batchSize": {
        "type": "int32",
        "text": "Количество.\nПо умолчанию 10.\n# Диапазон: 10..5000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Минимум: 10"
          },
          "max": {
            "value": 5000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 5000"
          },
        }
      },
      /**
       * Дата, старше которой должны вернуться записи для синхронизации
       */
      "lastSyncBeforeAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата, старше которой должны вернуться записи для синхронизации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения списка домов для обновления
   */
  "GetSyncBuildingsResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка домов для обновления",
    "fields": {
      /**
       * Дома
       */
      "data": {
        "type": "GetSyncBuildingsResponse.BuildingList",
        "text": "Дома",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSyncBuildingsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Список домов
   */
  "GetSyncBuildingsResponse.BuildingList": {
    "kind": "class",
    "text": "Список домов",
    "fields": {
      /**
       * Список домов
       */
      "buildings": {
        "type": "BuildingSync",
        "text": "Список домов",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetSyncBuildingsResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос частичного обновления дома
   */
  "PostSyncBuildingRequest": {
    "kind": "class",
    "text": "Запрос частичного обновления дома",
    "fields": {
      /**
       * Передается в случае когда изменения данных не требуются, но необходимо зафиксировать дату синхронизации
       */
      "buildingId": {
        "type": "int32",
        "text": "Передается в случае когда изменения данных не требуются, но необходимо зафиксировать дату синхронизации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дом с обновленными данными из DaData
       */
      "data": {
        "type": "BuildingSync",
        "text": "Дом с обновленными данными из DaData",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос частичного обновления дома
   */
  "PostSyncBuildingResponse": {
    "kind": "class",
    "text": "Ответ на запрос частичного обновления дома",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostSyncBuildingResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PostSyncBuildingResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}